import React from "react";

function Footer() {
	return (
		<footer className="footer">
			<div>
				<a
					href="https://github.com/RyanAcham"
					target="_blank"
					rel="noopener noreferrer"
				>
					<img
						src={require("../assets/github-logo.png")}
						alt="Github"
						className="logo"
					></img>
				</a>
			</div>
			<div>
				<a
					href="https://www.linkedin.com/in/ryan-acham-01b156237/"
					target="_blank"
					rel="noopener noreferrer"
				>
					<img
						src={require("../assets/linkedin-logo.png")}
						alt="LinkedIn"
						className="logo"
					></img>
				</a>
			</div>
		</footer>
	);
}

export default Footer;